export { default } from "./contains.mjs";